
import {NgModule} from '@angular/core' 
import { CommonModule } from '@angular/common';
import { LimiteWordsPipe } from './limitewords.pipe';
@NgModule({
  imports: [
    // CommonModule
    // dep modules
  ],
  declarations: [ 
    LimiteWordsPipe
  ],
  exports: [
    LimiteWordsPipe
  ]
})
export class AppPipesModule {
  static forRoot() {
    return {
        ngModule: AppPipesModule,
        providers: [],
    };
 }
}


// WEBPACK FOOTER //
// ./src/pipes/index.module.ts